import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import { Logs as LogsIcon, SettingsCog as SettingsCogIcon } from 'common/icons'
import {
  getContentHasVariants,
  getIsOptimized,
} from 'features/unifiedFlow/contentPage/helpers'
import {
  useContent,
  useSelectedElement,
} from 'features/unifiedFlow/contentPage/hooks'

import ExportMenuButton from '../../components/layout/components/ExportMenuButton'

import { HandleActivePanelChange } from './RightSection'

type Props = {
  integrationTitle?: string
  handleActivePanelChange: HandleActivePanelChange
}

const CollapsedIcons = ({
  integrationTitle,
  handleActivePanelChange,
}: Props) => {
  const { content } = useContent()
  const { data: selectedElement } = useSelectedElement()

  const isOptimized = getIsOptimized(selectedElement)
  const hasVariants = getContentHasVariants(content)

  const commonClassName = 'text-gold-600 cursor-pointer hover:text-gold-700'

  return (
    <>
      {isOptimized && integrationTitle && (
        <ButtonWithTooltip
          data-testid="optimizeIntegration-sidebar-button"
          variant="icon"
          tooltip
          tooltipText={integrationTitle}
          placement="left"
          prefixIcon={
            <SettingsCogIcon
              size={6}
              isDefaultColor={false}
              className={commonClassName}
            />
          }
          onClick={() => handleActivePanelChange('optimizeIntegration')}
        />
      )}
      {!isOptimized && (
        <ButtonWithTooltip
          data-testid="integrationLogs-sidebar-button"
          variant="icon"
          tooltip
          tooltipText="Logs"
          placement="left"
          prefixIcon={
            <LogsIcon
              size={6}
              isDefaultColor={false}
              className={commonClassName}
            />
          }
          onClick={() => handleActivePanelChange('integrationLogs')}
        />
      )}
      {selectedElement && hasVariants && (
        <div className="flex items-stretch" style={{ height: '38px' }}>
          <ExportMenuButton tooltipPlacement="left" />
        </div>
      )}
      {isOptimized && (
        <ButtonWithTooltip
          data-testid="campaignLogs-sidebar-button"
          variant="icon"
          tooltip
          tooltipText="Logs"
          placement="left"
          prefixIcon={
            <LogsIcon
              size={6}
              isDefaultColor={false}
              className={commonClassName}
            />
          }
          onClick={() => handleActivePanelChange('campaignLogs')}
        />
      )}
    </>
  )
}

export default CollapsedIcons
